import requestAction from '../../utils/requestAction'

export const fetchProvinces = (params: string) =>
  requestAction('PROVINCE_LIST', params)(`provinces`, 'GET')
